import { Urls } from "types/urls.types";

export const urls: Urls = {
    API_HOST_URL: process.env.REACT_APP_API_HOST_URL!
};
